export default function formatNumber(num, options) {
  if (typeof num !== 'number' || Number.isNaN(num)) return null;

  const numberString = num.toLocaleString('en-US', {
    ...options,
  });

  return numberString;
}
